"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BuildingInfoSection_1 = __importDefault(require("./BuildingInfoSection"));
var DeveloperInfoSection_1 = __importDefault(require("./DeveloperInfoSection"));
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var MortgageSection_1 = __importDefault(require("../../MortgageSection"));
var ApartmentsSection_1 = __importDefault(require("./ApartmentsSection"));
var objectHelper_1 = require("../../../../helpers/objectHelper");
var DeveloperPostSections = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var postData = _a.postData, currentTab = _a.currentTab, handleSelectTab = _a.handleSelectTab, setPostMedia = _a.setPostMedia, handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias, isMortgageButtonClicked = _a.isMortgageButtonClicked, setIsMortgageButtonClicked = _a.setIsMortgageButtonClicked, setApartmentsTablePositionY = _a.setApartmentsTablePositionY, isRent = _a.isRent, setIsRelatedPostClicked = _a.setIsRelatedPostClicked, isRelatedPostClicked = _a.isRelatedPostClicked;
    var _h = react_1.useState([]), freeApartments = _h[0], setFreeApartments = _h[1];
    react_1.useEffect(function () {
        var _a;
        if (!freeApartments.length) {
            var freeApartments_1 = (_a = postData.sections.apartment_info) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, arg) {
                if (arg.availability === PostViewContentTypes_1.POST_AVAILABILITY.SALE) {
                    return __spreadArray(__spreadArray([], acc), [
                        objectHelper_1.combineApartmentsData({
                            apt_number: arg.sub_building + "-" + arg.apt_number,
                            price: arg.price,
                            currency: arg.currency,
                        }),
                    ]);
                }
                else {
                    return acc;
                }
            }, []);
            freeApartments_1 && setFreeApartments(freeApartments_1);
        }
    }, [postData]);
    var redirectToMortgageSection = function (_a) {
        var price = _a.price, apt_number = _a.apt_number, sub_building = _a.sub_building;
        var unselectedApartments = freeApartments.filter(function (item) { return item.text !== sub_building + "-" + apt_number; });
        handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO);
        setFreeApartments(__spreadArray([
            objectHelper_1.combineApartmentsData({
                apt_number: sub_building + "-" + apt_number,
                price: price[0].price,
                currency: price[0].currency,
            })
        ], unselectedApartments));
    };
    return (react_1.default.createElement("div", null, currentTab === PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO ? (react_1.default.createElement(DeveloperInfoSection_1.default, { email: postData.user.email, description: (_b = postData.developer) === null || _b === void 0 ? void 0 : _b.description, phone: (_c = postData.contacts[0]) === null || _c === void 0 ? void 0 : _c.formattedPhone, developerName: (_d = postData.developer) === null || _d === void 0 ? void 0 : _d.name, developerLogo: postData.developerLogo, website: (_e = postData.developer) === null || _e === void 0 ? void 0 : _e.website, relatedPosts: postData.relatedPosts, setIsRelatedPostClicked: setIsRelatedPostClicked, isRelatedPostClicked: isRelatedPostClicked, dateOfEstablishment: (_f = postData.developer) === null || _f === void 0 ? void 0 : _f.date_of_establishment, developerProjects: (_g = postData.developer) === null || _g === void 0 ? void 0 : _g.developer_projects })) : currentTab === PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO ? (react_1.default.createElement(BuildingInfoSection_1.default, { postData: postData })) : currentTab === PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO ? (react_1.default.createElement(ApartmentsSection_1.default, { postData: postData, redirectToMortgageSection: redirectToMortgageSection, setPostMedia: setPostMedia, handleScrollToShowMobileMedias: handleScrollToShowMobileMedias, isMortgageButtonClicked: isMortgageButtonClicked, setIsMortgageButtonClicked: setIsMortgageButtonClicked, setApartmentsTablePositionY: setApartmentsTablePositionY, isRent: isRent })) : currentTab === PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO ? (react_1.default.createElement(MortgageSection_1.default, { isDeveloper: postData.isDeveloper, freeApartments: freeApartments, region: postData.addressData.state, district: postData.addressData.district, address: postData.addressData.address, mortgage: postData.sections.mortgage, propertyType: postData.propertyType })) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = DeveloperPostSections;
